<div class="map-wrapper">
  <div #mapContainer class="map-container" [style.height]="height">
    <div class="map-loading" *ngIf="!mapLoaded">
      <i class="pi pi-spin pi-spinner"></i>
      <span style="color: #0B0C0E">Loading map...</span>
    </div>
  </div>


  <!-- Zoom Controls -->
  <div class="zoom-controls">
    <button pButton class="p-button-rounded p-button-text" (click)="zoomIn()" [pTooltip]="'Zoom In' | translate"
            tooltipPosition="top">
      <i class="pi pi-plus"></i>
    </button>
    <button pButton class="p-button-rounded p-button-text" (click)="zoomOut()" [pTooltip]="'Zoom Out' | translate"
            tooltipPosition="top">
      <i class="pi pi-minus"></i>
    </button>
  </div>


  @if (showControls) {
    <div class="draw-control">
      <!--    <button-->
      <!--      pButton-->
      <!--      class="p-button-rounded p-button-text"-->
      <!--      [class.active]="drawingMode"-->
      <!--      (click)="toggleDrawing()">-->
      <!--      <i class="pi pi-pencil"></i>-->
      <!--    </button>-->
      <button
        pButton
        class="p-button-rounded p-button-text" [pTooltip]="'Center Map' | translate" tooltipPosition="top"
        [class.active]="drawingMode"

        (click)="centerMap()">
        <img
          [src]="'map-center' | iconPath"
          alt="Map"
          class="map-icon"
        />
      </button>
    </div>
    <!-- Image Control -->
    <div class="image-control flex flex-row gap-1">
      <button
        pButton
        class="p-button-rounded p-button-text" [pTooltip]="'Toggle Satellite Layer' | translate" tooltipPosition="top"
        (click)="toggleSatelliteLayer()">
        <img
          [src]="'download-satellite-data' | iconPath"
          alt="Map"
          class="map-icon"
        />
      </button>

      @if (drawingOptions.point) {
        <button
          pButton
          class="p-button-rounded p-button-text" [pTooltip]="'Draw Point' | translate" tooltipPosition="top"
          (click)="stopPolygonDrawing()">
          <img
            [src]="'map-draw-point' | iconPath"
            alt="Map"
            class="map-icon"
          />
        </button>
      }

      @if (drawingOptions.polygon) {
        <button
          pButton
          class="p-button-rounded p-button-text" [pTooltip]="'Draw Polygon' | translate" tooltipPosition="top"
          (click)="stopPolygonDrawing();startPolygonDrawing()">
          <img
            src="assets/icons/main/light/sixers-black.svg"
            style="height: 20px; width: 20px;"
            alt="Map"
            class="map-icon"
          />
        </button>
      }

    </div>
  }

</div>

